import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_020_emp_grp_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Employee group",
        style: {
            backgroundColor: "#F9FAFB",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    direction: FlexDirection.ROW,
                    padding: 10,
                },
                childComponents: [
                    // {
                    //     componentType: ComponentType.BUTTON,
                    //     Label: "Back",
                    //     style: {
                    //         backgroundColor: "#1f2937", // btn-dark
                    //         textColor: "#ffffff",
                    //         padding: 8,
                    //         borderRadius: 4,
                    //     },
                    //     onPressAction: "modulev1/emp_grp_summary",
                    // },
                ],
            },
            {
                componentType: LayoutTypes.FORM,
                Name: "emp_grp_add",
                TableName: "employee_group",
                DisplayName: "Employee group",
                style: {
                    backgroundColor: "#ffffff",
                    padding: 16,
                    borderRadius: 8,
                },
                Fields: [
                    {
                        IncludeLabel: true,
                        Label: "Name",
                        BindValue: "txt_name",
                        Json_Attribute: "group_name",
                        componentType: ComponentType.TEXT_FIELD,
                        IsMandatory: true,
                        IsVerticalView: true,
                    },
                ],
            },
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    direction: FlexDirection.ROW,
                    gap: 10,
                    padding: 10,
                },
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        Label: "Submit",
                        onPressAction: "save",
                        ActionType: "Add",
                        ScreenId: "20",
                        style: {
                            backgroundColor: "#2563eb", // btn-primary
                            textColor: "#ffffff",
                            padding: 12,
                            borderRadius: 8,
                        },
                    },
                    // {
                    //     componentType: ComponentType.BUTTON,
                    //     Label: "Cancel",
                    //     onPressAction: "modulev1/emp_grp_summary",
                    //     style: {
                    //         backgroundColor: "#6b7280", // btn-secondary
                    //         textColor: "#ffffff",
                    //         padding: 12,
                    //         borderRadius: 8,
                    //     },
                    // },
                ],
            },
        ],
    },
];
